import React, { PureComponent } from 'react'
import * as R from 'ramda'
import ReportPage from './ReportPage'
import ReportStat from './ReportStat'
import DeviceBrowser from './DeviceBrowser'
import XTabs from './XTabs'
import ReportHeader from './ReportHeader'
import EditAnswersModal from './EditAnswersModal'

class RightPanel extends PureComponent {
    componentDidMount() {
        const { reportStore } = this.props
        this.element = document.getElementById('pane2')
        reportStore.element = this.element
        this.topOffset = this.element.getBoundingClientRect().top
        window.addEventListener('resize', this.resize)
        this.resize()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize)
    }

    getPagesElements = () => {
        const {
            store,
            reportFilter,
            reportData,
            locale,
            showDebug,
            updated,
            reportStore,
            dataUpdated,
        } = this.props

        return reportStore.reportPages.map((page, i) => (
            <ReportPage
                page={page}
                reportStore={reportStore}
                store={store}
                scrollTop={this.scrollTop}
                reportFilter={reportFilter}
                showDebug={showDebug}
                reportData={reportData}
                locale={locale}
                updated={updated}
                dataUpdated={dataUpdated}
                index={i}
            />
        ))
    }

    resize = () => {
        if (!this.windowH || this.windowH !== window.innerHeight) {
            document.getElementById('pane2').style.height = `${(window.innerHeight - this.topOffset - 20)}px`
            this.windowH = window.innerHeight
        }
    }

    scrollTop = () => {
        this.element.scrollTop = 0
    }

    scrollBottom = () => {
        this.element.scrollTop = this.element.scrollHeight
    }

    scrollTo = (e) => {
        try {
            const pageId = e.target.getAttribute('pageId')
            document.getElementsByClassName(`toggle_${pageId}`)[0].scrollIntoView()
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        const {
            loading,
            store,
            reportStore,
            reportFilter,
        } = this.props
        const { survey } = store
        const showNonMaxbi = R.pathOr(undefined, ['metadata', 'taxonomy', 'surveyType'], survey) !== 'EM'
        return (
            <div id="pane2">
                {!loading
                    && (
                        <div id="report">
                            <ReportHeader store={store} reportStore={reportStore} />
                            {showNonMaxbi && (
                                <ReportStat
                                    reportStore={reportStore}
                                    store={store}
                                    data={reportStore.reportData.stats}
                                    loading={loading}
                                    scrollTo={this.scrollTo}
                                />
                            )}
                            {this.getPagesElements()}
                            <hr className="clear" />
                            {showNonMaxbi && (
                                <DeviceBrowser
                                    store={store}
                                    reportStore={reportStore}
                                    deviceData={reportStore.reportData.devicesData}
                                    browserData={reportStore.reportData.browserData}
                                    loading={loading}
                                />
                            )}
                            <XTabs
                                reportStore={reportStore}
                                store={store}
                                reportFilter={reportFilter}
                                scrollBottom={this.scrollBottom}
                            />
                            <EditAnswersModal
                                reportStore={reportStore}
                                toggleEditAnswers={() => { reportStore.editAnswersModalIsOpen = false }}
                                editAnswersOpen={reportStore.editAnswersModalIsOpen}
                                surveyURL={reportStore.editAnswersURL}
                            />
                        </div>
                    )}
            </div>
        )
    }
}

export default RightPanel
